import React, {useEffect, useRef, useState} from 'react'
import {useAuth} from '../../../../../modules/auth'
import moment from "moment";

interface PiecePanier {
  idPiecePropose: number | string // Nouvelle clé
  marque?: string
  modele?: string
  isVHT?: boolean
  immat?: string
  nomTypePiece?: string
  nomTypePieceHN?: string
  nomTypePieceProposee?: string
  codePieceEntree?: string
  marquePiece?: string
  modelePiece?: string
  refConstructeur?: string
  prixReferentiel?: number
  prixReferentielHt?: number
  prixReferentielTtc?: number
  prixVenteProposee: number
  prixVenteProposeeHt?: number
  prixVenteProposeeTtc?: number
  isTypePiecePOT?: boolean
  tauxRemise?: number
}

interface LibelleDevis {
  id: number | string;
  libelle: string;
  clientDemandePieceProposee?: {
    id: number | string; // Clé de correspondance
  };
  commentaire: string | null
}

const PdfPreview = (props) => {
  const {
    libelleList,
    aProposerPanier,
    dataClientInfos,
    demandeId,
    now,
    dateStr,
    contentRef,
    otherData,
    dataVehicule,
    adresseFacturation,
    computeSources,
    displayHistory,
    historiqueDevis,
    activeHistorique,
    totalDevis,
    setTotalDevis,
    retraitDepot,
    getAdresseRetraitDepot = () => {},
  } = props

  const {currentUser} = useAuth() //utilisateur connecté

  const numeroOffre = displayHistory
    ? `DEV-${moment(historiqueDevis?.[activeHistorique]?.dateCreation).format('YYYYMMDDhhmmss')}${demandeId}`
    : `DEV-${dateStr}${demandeId}`

  const date = displayHistory
    ? moment(historiqueDevis?.[activeHistorique]?.dateCreation).format('DD/MM/YYYY')
    : now

  const panier = displayHistory
    ? historiqueDevis?.[activeHistorique]?.panier
    : null

  const libelle = displayHistory
    ? historiqueDevis?.[activeHistorique]?.libelle
    : libelleList

  const contactedBy = displayHistory
    ? historiqueDevis?.[activeHistorique]?.contactedBy
    : otherData?.contactedBy

  const utilisateurAssigne = displayHistory
    ? `${historiqueDevis?.[activeHistorique]?.utilisateurAssigne?.prenom} ${historiqueDevis?.[activeHistorique]?.utilisateurAssigne?.nom.charAt(0).toUpperCase()}.`
    : `${currentUser?.prenom} ${currentUser?.nom.charAt(0).toUpperCase()}.`

  const client = displayHistory
    ? historiqueDevis?.[activeHistorique]?.client
    : dataClientInfos

  const {isAuto, isMoto, isIndus} = computeSources

  //Taux tva par rapport au client professionnel ou particulier
  let isProfessionnel = (client && client?.professionnel === false) ? 10 : 20
  //total TTC
  let totalPrixVenteProposeeHt = 0
  let totalPrixVenteProposeeTtc = 0

  const floatToNumber = (number: string | number) => {
    return Number(Number(number)?.toFixed(2))
  }

  // const renderPieceDevis = (aProposerPanier) => {
  //   if (!aProposerPanier || aProposerPanier.length === 0) {
  //     return null
  //   }
  //
  //   return aProposerPanier.map((piece, index) => {
  //     //TTC pour chaque pièce:
  //     let montantTVA = piece?.prixVenteProposee * (isProfessionnel / 100)
  //     let totalTTC = montantTVA + floatToNumber(piece?.prixVenteProposee)
  //     let TTCFn = floatToNumber(totalTTC)
  //     TTCPiece += TTCFn
  //     return (
  //       <tr key={index}>
  //         <td style={{maxWidth: '140px'}}>
  //           <div>
  //             <p>
  //               {piece?.marque} {piece?.modele} {piece?.isVHT ? '[VHT]' : ''}
  //             </p>
  //             <span>{!piece?.immat?.includes(' - ') ? piece?.immat : ''}</span>
  //           </div>
  //         </td>
  //         <td style={{maxWidth: '140px'}}>{piece?.nomTypePiece}</td>
  //         <td style={{maxWidth: '140px'}}>{piece?.codePieceEntree}</td>
  //         <td style={{maxWidth: '140px'}}>
  //           <div>
  //             <p>
  //               {piece?.marquePiece} {piece?.modelePiece}
  //             </p>
  //             <span>{piece?.nomTypePiece}</span>
  //           </div>
  //         </td>
  //         <td style={{maxWidth: '140px'}}>{piece?.refConstructeur}</td>
  //         <td>1</td>
  //         <td style={{maxWidth: '140px'}}>{piece?.prixVenteProposee} €</td>
  //         <td style={{maxWidth: '140px'}}>{piece?.prixVenteProposee} €</td>
  //         <td style={{maxWidth: '140px'}}>{TTCFn} €</td>
  //       </tr>
  //     )
  //   })
  // }

  // const renderLibelleDevis = (libelle) => {
  //   if (!libelle || libelle.length === 0) {
  //     return null
  //   }
  //
  //   return (
  //     libelle.length > 0 &&
  //     libelle.map((libelle, index) => {
  //       //si le libelle est "frais de port" , donc on ne l'affiche pas
  //       if (libelle?.libelle === 'Frais port') {
  //         return
  //       }
  //
  //       return (
  //         <tr key={index}>
  //           <td>-</td>
  //           <td style={{maxWidth: '140px'}}>{libelle?.libelle}</td>
  //           <td>-</td>
  //           <td>-</td>
  //           <td>-</td>
  //           <td>-</td>
  //           <td>-</td>
  //           <td>-</td>
  //           <td>-</td>
  //         </tr>
  //       )
  //     })
  //   )
  // }

  const renderInfoVehicule = () => {
    const dataVehiculeHistorique = panier
      ?.map((p) => ({
        immatriculation: p?.immat,
        marque: p?.marque,
        modele: p?.modele,
        cnit: p?.cnit,
        vin: p?.vin,
        isVHT: p?.isVHT
      })).filter((vehicule, index, self) =>
          index === self.findIndex((v) =>
            v.immatriculation === vehicule.immatriculation &&
            v.marque === vehicule.marque
          )
      )

    const currentDataVehicule = displayHistory ? dataVehiculeHistorique : dataVehicule

    if (!currentDataVehicule || currentDataVehicule.length === 0) {
      return null
    }

    return (
      currentDataVehicule.length > 0 &&
      currentDataVehicule.map((vehicule, index) => (
        <tr key={index}>
          <td>
            {vehicule?.marque} {vehicule?.modele} {vehicule?.isVHT ? '[VHT]' : ''}
          </td>
          <td>{!vehicule?.immatriculation?.includes(' - ') ? vehicule?.immatriculation : ''}</td>
          <td>
            {vehicule?.vin} {vehicule?.cnit}
          </td>
        </tr>
      ))
    )
  }

  // Recalcul total devis
  useEffect(() => {
    let totalPiece: number = 0
    let totalTransort: number = 0

    const currentPanier = displayHistory ? panier : aProposerPanier

    if (!currentPanier || currentPanier.length === 0) {
      setTotalDevis(0)
      totalPiece = 0
      totalTransort = 0
    } else {
      // Somme des pièces à proposer
      totalPiece = (currentPanier ?? []).reduce((sum, piece) => sum + Number(piece?.prixVenteProposeeHt || 0), 0)
      // Somme des totals transports
      totalTransort = (currentPanier ?? []).reduce(
        (sum, piece) => sum + Number(piece?.fraisDePort || 0),
        0
      )
    }

    // Somme des libellés de type frais de port
    const totalLibelle = retraitDepot !== undefined && retraitDepot ? 0 : Array.isArray(libelle)
      ? libelle.reduce((sum, libelle) => {
          if (libelle?.libelle === 'PORTP') {
            return sum + Number(libelle?.prixUnitaire || 0) * Number(libelle?.quantite || 1)
          }
          return sum
        }, 0)
      : 0

    const tvaTransport = 20 //toujours 20% pour le transport
    let totalTransportLibelleHT = Number(totalTransort + totalLibelle)
    let totalTransportLibelleTTC = Number((totalTransort + totalLibelle) * (1 + (tvaTransport / 100)))

    const totalDevis: number = Number(totalPiece) + Number(totalLibelle) + Number(totalTransort)
    // const tva: number = (Number(totalDevis) * 20) / 100
    // const totalTTC: number = totalDevis + tva
    setTotalDevis({
      totalHT: Number(totalDevis.toFixed(2)),
      totalTransportHT: Number(Number(totalTransportLibelleHT).toFixed(2)),
      totalTransportTTC: Number(Number(totalTransportLibelleTTC).toFixed(2)),
    })
  }, [aProposerPanier, libelle, displayHistory, historiqueDevis, activeHistorique])

  // Fonctions utilitaires (à placer avant le return du composant)
  const renderPieceRow = (piece: PiecePanier, key: string, isProfessionnel: number) => {
    const prixVenteProposeeHt = Number(piece.prixVenteProposeeHt ?? 0)
    const prixVenteProposeeTtc = Number(piece.prixVenteProposeeTtc ?? 0)

    const prixReferentielHt =  Number(piece.prixReferentielHt ?? 0)

    totalPrixVenteProposeeHt += prixVenteProposeeHt
    totalPrixVenteProposeeTtc += prixVenteProposeeTtc

    return (
      <tr key={key}>
        <td style={{maxWidth: '140px'}}>{piece.nomTypePieceProposee}</td>
        <td style={{maxWidth: '140px'}}>{piece.marquePiece}</td>
        <td style={{maxWidth: '140px'}}>{piece.modelePiece}</td>
        <td style={{maxWidth: '140px'}}>{piece.codePieceEntree}</td>
        {/*<td style={{maxWidth: '140px'}}>{piece.refConstructeur}</td>*/}
        <td>1</td>
        <td style={{maxWidth: '140px'}}>
          {client?.professionnel ? `${prixReferentielHt?.toFixed(2)} €` : ''}
        </td>
        <td>{!piece?.isTypePiecePOT && (piece?.tauxRemise ?? 0) > 0 ? `- ${piece?.tauxRemise}%` : ''}</td>
        <td style={{maxWidth: '140px'}}>
          {client?.professionnel ? `${prixVenteProposeeHt?.toFixed(2)} €` : ''}
        </td>
        <td style={{maxWidth: '140px'}}>{prixVenteProposeeTtc?.toFixed(2)} €</td>
      </tr>
    )
  };

  const renderLibelleRow = (libelle: LibelleDevis, key: string) => (
    <tr key={key}>
      <td>-</td>
      <td colSpan={8}>{libelle.commentaire}</td>
      {/*<td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td><td>-</td>*/}
    </tr>
  )

  return (
    <div
      style={{ width: displayHistory ? "60%" : "70%" }}
      className={'border border-muted rounded-1 p-9'}
      ref={contentRef}
      id='pdf-print-section'
    >
      <div className='d-flex justify-content-between'>
        {isAuto && (
          <img
            src='/media/logos/facture-surplus-autos.jpg'
            alt='logo'
            style={{width: '450px', height: 'auto'}}
          />
        )}
        {isMoto && (
          <img
            src='/media/logos/facture-surplus-motos.jpg'
            alt='logo'
            style={{width: '450px', height: 'auto'}}
          />
        )}
        {isIndus && (
          <img
            src='/media/logos/facture-surplus-industrie.jpg'
            alt='logo'
            style={{width: '450px', height: 'auto'}}
          />
        )}
        <div className={'d-flex flex-column align-items-end'}>
          <h3>PROPOSITION DE PIECES</h3>
          <div>N° OFFRE {numeroOffre}</div>
          <div>Date: {date}</div>

          <div className='text-primary my-4'>Valable 30 jours</div>
        </div>
      </div>
      <div className='text-gray-700 my-6'>
        <div className='font-weight-bold'>A l'attention de :</div>
        <div className='d-flex justify-content-between'>
          <div>
            {contactedBy?.nom}{' '}{contactedBy?.prenom}
          </div>
          <div>
            Offre réalisée par : {utilisateurAssigne}
          </div>
        </div>
        <div>
          {contactedBy?.telephone}{' '}{contactedBy?.mobile && `/ ${contactedBy?.mobile}`}
        </div>
        <div>{contactedBy?.email}</div>
      </div>

      {/*debut affichage info vehicule et affichage de info client adresse facturation*/}
      <div className='d-flex flex-row mb-6' style={{width: '100%', gap: '20px'}}>
        {/*debut tableau d'info vehicule*/}
        <div className='' style={{width: '70%'}}>
          <table className='table table-row-dashed table-row-gray-300'>
            <thead>
              <tr>
                <th>Marque/Modèle</th>
                <th>Immatriculation</th>
                <th>VIN / CNIT</th>
              </tr>
            </thead>
            <tbody>{renderInfoVehicule()}</tbody>
          </table>
        </div>
        {/*fin tableau d'info vehicule*/}

        {/*  debut affichage info client adresse facturation*/}
        <div className='bg-gray-300 rounded-1 p-3' style={{width: '30%'}}>
          <div className='d-flex flex-column'>
            {adresseFacturation?.length > 0 ? (
              <>
                <span>{adresseFacturation?.libelle}</span>
                <span>{adresseFacturation?.adresse}</span>
                <span>{adresseFacturation?.complementAdresse}</span>
                <span>
                  {adresseFacturation?.codePostal} {adresseFacturation?.ville}
                </span>
              </>
            ) : (
              <>
                <span>
                  {' '}
                  {client?.nomSociete
                    ? client?.nomSociete + '-' + client?.email
                    : client?.email}
                </span>
                <span>{client?.adresse}</span>
                <span>{client?.complementAdresse}</span>
                {/*<span>*/}
                {/*  {client?.telephone} {client?.mobile && `/ ${client.mobile}`}*/}
                {/*</span>*/}
                <span>
                  {client?.codePostal} {client?.ville}
                </span>
                <span>{client?.pays?.nom}</span>
              </>
            )}
          </div>
        </div>
        {/*  fin affichage info client adresse facturation*/}
      </div>
      {/*fin affichage info vehicule et affichage de info client adresse*/}

      <div className=''>
        <table className='table table-row-dashed table-row-gray-300'>
          <thead>
            <tr>
              <th>Libellé</th>
              <th>Marque</th>
              <th>Modèle</th>
              <th>Code pièce interne</th>
              {/*<th>Référence constructeur</th>*/}
              <th>Qté</th>
              <th>PU HT</th>
              <th>Remise</th>
              <th>Total HT</th>
              <th>TTC</th>
            </tr>
          </thead>
          <tbody>
          {(() => {
            const usedLibelleIds = new Set<string | number>()

            const matchedGroups = ((displayHistory ? panier : aProposerPanier) || []).map(
              (piece) => {
                const children = (libelle || []).filter((libelle) => {
                  const matchingId = libelle.clientDemandePieceProposee?.id
                  const isMatch = matchingId === piece.idPiecePropose
                  const isNotFraisPort = libelle.libelle !== 'Frais port'

                  if (isMatch && isNotFraisPort) {
                    usedLibelleIds.add(libelle.id)
                    return true
                  }
                  return false
                })

                return {piece, children}
              }
            )

            // Regroupement par type de pièce (ordre = première apparition du type)
            const groupsByType = new Map<string | number, typeof matchedGroups>()
            matchedGroups.forEach((group) => {
              const typeId =
                group.piece.idTypePiecePropose ??
                group.piece.idTypePiece ??
                `no-type-${group.piece.idPiecePropose}`
              if (!groupsByType.has(typeId)) {
                groupsByType.set(typeId, [])
              }
              groupsByType.get(typeId)!.push(group)
            })

            // Séparation : groupes avec groupeLIBPR non null / groupes sans
            const entriesWithGroupeLIBPR: [string | number, typeof matchedGroups][] = []
            const entriesWithoutGroupeLIBPR: [string | number, typeof matchedGroups][] = []

            groupsByType.forEach((groups, typeId) => {
              const hasGroupeLIBPR = groups.some((g) =>
                g.children.some((child) => child.groupeLIBPR != null)
              )
              ;(hasGroupeLIBPR ? entriesWithGroupeLIBPR : entriesWithoutGroupeLIBPR).push([
                typeId,
                groups,
              ])
            })

            // Les libellés LIBPR sont regroupés en fin de groupe ; les autres types (ex. LIBFRP) restent sous leur pièce
            const isLibpr = (child: any) => child.libelle === 'LIBPR'

            // Libellés LIBPR dédoublonnés par commentaire
            const uniqueLibprByComment = (children: any[]) => {
              const seen = new Set<string>()
              return children.filter((child) => {
                if (!isLibpr(child) || seen.has(child.commentaire)) return false
                seen.add(child.commentaire)
                return true
              })
            }

            // Pièces d'un groupe, chacune suivie de ses libellés non-LIBPR
            const renderGroupPieces = (groups: typeof matchedGroups, prefix: string) =>
              groups.map((group, i) => (
                <React.Fragment key={`${prefix}-${i}`}>
                  {renderPieceRow(group.piece, `p-${prefix}-${i}`, isProfessionnel)}
                  {group.children
                    .filter((child) => !isLibpr(child))
                    .map((child, ci) => renderLibelleRow(child, `l-own-${prefix}-${i}-${ci}`))}
                </React.Fragment>
              ))

            // Libellés réellement orphelins : non rattachés au panier ET sans pièce liée.
            // Ceux liés à une pièce absente de la liste sont volontairement masqués.
            const libelleOrphans = (libelle || []).filter(
              (l) =>
                !usedLibelleIds.has(l.id) &&
                l.libelle !== 'Frais port' &&
                l.clientDemandePieceProposee?.id == null
            )

            // LIBPR communs : pièces des groupes sans groupeLIBPR + orphelins LIBPR,
            // dédoublonnés ensemble par commentaire (les pièces passent en premier)
            const sharedLibpr = uniqueLibprByComment([
              ...entriesWithoutGroupeLIBPR.flatMap(([, groups]) =>
                groups.flatMap((g) => g.children)
              ),
              ...libelleOrphans,
            ])

            // Orphelins non-LIBPR uniquement (les LIBPR sont déjà dans sharedLibpr)
            const otherOrphans = libelleOrphans.filter((l) => !isLibpr(l))

            return (
              <>
                {/* Groupes avec groupeLIBPR : libellés LIBPR en fin de chaque groupe */}
                {entriesWithGroupeLIBPR.map(([typeId, groups]) => (
                  <React.Fragment key={`type-libpr-${typeId}`}>
                    {renderGroupPieces(groups, `libpr-${typeId}`)}
                    {uniqueLibprByComment(groups.flatMap((g) => g.children)).map((child, ci) =>
                      renderLibelleRow(child, `l-libpr-${typeId}-${ci}`)
                    )}
                  </React.Fragment>
                ))}

                {/* Groupes sans groupeLIBPR : toutes les pièces à la suite */}
                {entriesWithoutGroupeLIBPR.map(([typeId, groups]) => (
                  <React.Fragment key={`type-${typeId}`}>
                    {renderGroupPieces(groups, `${typeId}`)}
                  </React.Fragment>
                ))}

                {/* ...puis les libellés LIBPR communs, une seule fois */}
                {sharedLibpr.map((child, ci) => renderLibelleRow(child, `l-shared-${ci}`))}

                {/* Libellés orphelins (hors LIBPR) */}
                {otherOrphans.map((libelle, i) => renderLibelleRow(libelle, `l-o-${i}`))}
              </>
            )
          })()}

            {/* debut affichage du transport*/}
            <tr>
              <td>TRANSPORT</td>
              <td>{retraitDepot ? 'Retrait dépôt Surplus' : ''}</td>
              <td></td>
              <td></td>
              <td>1</td>
              <td>{retraitDepot ? '' : `${totalDevis?.totalTransportHT} €`}</td>
              <td></td>
              <td>{retraitDepot ? '' : `${totalDevis?.totalTransportHT} €`}</td>
              <td>{retraitDepot ? 'Offert' : `${totalDevis?.totalTransportTTC} €`}</td>
            </tr>
            {/*fin affichage transport*/}
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>
                {(() => {
                  const totalHt = client?.professionnel ? totalPrixVenteProposeeHt : totalPrixVenteProposeeTtc
                  const roundedTotal = Math.floor(totalHt * 100) / 100
                  const totalValue = Number(Number((roundedTotal + totalDevis?.totalTransportHT) ?? 0)?.toFixed(2))
                  return <>
                    {totalValue} €
                  </>
                })()}
              </td>
              <td>
                {(() => {
                  const roundedTotal = Math.floor(totalPrixVenteProposeeTtc * 100) / 100
                  const totalValue = Number(Number((roundedTotal + totalDevis?.totalTransportTTC) ?? 0)?.toFixed(2))
                  return <>
                    {totalValue} €
                  </>
                })()}
              </td>
            </tr>
          </tbody>
        </table>
        {/*<div className={'d-flex justify-content-end'}>*/}
        {/*  <div className={'w-150px'}>*/}
        {/*    <div className={'d-flex justify-content-between'}>*/}
        {/*      <div>*/}
        {/*        <div>Total HT</div>*/}
        {/*        <div>TVA (20%)</div>*/}
        {/*      </div>*/}
        {/*      <div>*/}
        {/*        <div className={'text-end'}>{totalDevis?.totalHT} €</div>*/}
        {/*        <div className={'text-end'}>{totalDevis?.tva} €</div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <hr className={'text-muted'} />*/}
        {/*    <div className={'d-flex justify-content-between'}>*/}
        {/*      <div>*/}
        {/*        <div>Total TTC</div>*/}
        {/*      </div>*/}
        {/*      <div>*/}
        {/*        <div className={'text-end'}>{totalDevis?.totalTTC} €</div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
      <hr />
      {/*debut footer pdf*/}
      <div className=''>
        <div>
          Pas d'escompte pour paiement comptant. Le paiement postérieur à la date limite entrainera
          des pénalités de 3 fois le taux légal. Tout retard de règlement de la part d'un
          professionnel donnera lieu, outre les pénalités de retard, au paiement d'une indemnité
          forfaitaire de recouvrement de 40€. TVA : CODE 1 "régime particulier - Biens d'occasion"
          (CGI ann.II art.242 nonies A, I-16°) CODE 2 taux normal France Métropolitaine CODE 3
          exonération de TVA article 262 du CGI CODE 4 "Régime particulier - Bien d'occasion" (CGI
          ann.II art.242 nonies A, I-16°)
        </div>
        <div
          className='font-weight-bold width-100 text-center'
          style={{
            backgroundColor: isAuto ? '#db0f4f' : isIndus ? 'dodgerblue' : 'orange',
            border: '1px solid #dbdfe9',
            display: 'inline-block',
            overflow: 'hidden',
            marginTop: '20px',
            color: 'white',
            padding: '10px',
            width: '100%',
          }}
        >
          <div className='text-center'>
            {isAuto && (
              <>
                <div>
                  S.A.S SURPLUS AUTOS au capital de 200 000 euros, RCS Albi 334 499 622 - APE 46772Z
                  - TVA intra FR 95 334 489 622
                </div>
                <div>Siege social : 60, avenue Gustave Eiffel, Z.I.R Mas de Rest 81600 GAILAC</div>
              </>
            )}
            {isIndus && (
              <>
                <div>
                  S.A.S SURPLUS INDUSTRIE au capital de 100 000 euros, RCS Albi 834 349 557 - APE
                  46772Z - TVA intra FR 58 834 349 557
                </div>
                <div>Siege social : 161, avenue Gustave Eiffel, Z.I.R Mas de Rest 81600 GAILAC</div>
              </>
            )}
            {isMoto && (
              <>
                <div>
                  S.A.S SURPLUS MOTOS au capital de 158 910 euros, RCS Albi 519 002 471 - APE 46772Z
                  - TVA intra FR 95 519 02 471
                </div>
                <div>Siege social : 365, avenue Gustave Eiffel, Z.I.R Mas de Rest 81600 GAILAC</div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PdfPreview
